import React from "react";
import Store from "../../impianti/ImpiantiClienteStore";
import { ImpiantoLight, SetImpiantoKeyDto } from "../../generated";
import OpenModalButton from "../../common/components/openModalButton";
import { groupBy, map } from "lodash";
import { CheckBox } from "../../common/components/checkBox2";
import ImpiantiClienteActions from "../../impianti/ImpiantiClienteActions";
import Guid from "../../common/Guid";

interface Props {
    current: ImpiantoLight
}

export default (props: Props) => {
    const data = Store.useForCustomer(props.current.idCliente);
    if (data == null) return null;
    if (data.length <= 1)
        return null;

    return <OpenModalButton
        modalContent={<LinkableApparecchiSelector impianti={data} current={props.current} />}
        className="btn btn-outline-secondary me-1"
    >
        <i className="fas fa-link me-1" /> Raggruppa
    </OpenModalButton>
}

export const LinkableApparecchiSelector = (props: { impianti: ImpiantoLight[], current: ImpiantoLight }) => {
    const { impianti, current } = props;
    const filtered = props.current.groupKey == null ? impianti.filter(x => x.id != current.id) : impianti;
    const grouped = map(groupBy(filtered, x => x.groupKey ?? Guid.newGuid()), (group, key) => ({ key, group }))

    const onChange = (checked: boolean, groupKey: string | undefined, items: ImpiantoLight[]) => {
        if (checked) {
            ImpiantiClienteActions.setGroup(props.current.idCliente, { groupKey, impianti: [...items, current].map(x => x.id) } as SetImpiantoKeyDto);
        }
        else {
            ImpiantiClienteActions.setGroup(props.current.idCliente, { groupKey: undefined, impianti: [current.id] } as SetImpiantoKeyDto);
        }
    }

    return <div>
        <div className="fw-bold mb-2" style={{ fontSize: "1.3rem" }}>{current.groupKey ? "Impianti del gruppo" : "Impianti da collegare"}</div>
        <div className="list-group my-3">
            {grouped.map(x => {
                var currentSelected = x.group.some(i => i.id == current.id);
                return <div key={`group_${x.key}`} className="list-group-item d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <div className="me-3">
                            <CheckBox
                                checked={currentSelected}
                                disabled={currentSelected}
                                onChange={checked => onChange(checked, x.key, x.group)}
                            />
                        </div>
                        <div>
                            {x.group.map((imp, i) => <li key={imp.id} className="d-flex align-items-center">
                                <span className={imp.id == current.id ? "text-primary fw-bold" : ""}>
                                    {imp.marca}  {imp.modello}
                                </span>
                            </li>)}
                        </div>
                    </div>
                    {currentSelected && <button className="btn btn-danger" onClick={() => onChange(false, current.groupKey, x.group)}>
                        Dissocia {current.marca} {current.modello} dal gruppo
                    </button>}
                </div>
            })}
        </div>
    </div>
}



